<template>
    <div class="org-page">
        <div class="org-box">
            <el-card shadow="never" class="org-card">
                <div slot="header" class="card-header">
                    <span>组织架构</span>
                    <el-button type="primary" size="mini" icon="el-icon-plus"
                        @click="handleAddRoot">新增一级组织</el-button>
                </div>
                <el-input v-model="filterText" size="small" placeholder="搜索组织" clearable
                    style="margin-bottom:12px;"></el-input>
                <el-tree ref="orgTree" :data="treeData" node-key="id" default-expand-all highlight-current
                    :expand-on-click-node="false" :filter-node-method="filterNode" @node-click="handleNodeClick">
                    <span class="custom-tree-node" slot-scope="{node,data}">
                        <span class="tree-name">
                            {{ data.orgName }}
                        </span>
                        <span class="tree-actions">
                            <el-button v-if="data.isMemberNode !== 1" type="text" size="mini" @click.stop="handleAddChild(data)">新增子级</el-button>
                            <el-button type="text" size="mini" @click.stop="handleEdit(data)">编辑</el-button>
                            <el-button type="text" size="mini" class="danger-btn"
                                @click.stop="handleDelete(data)">删除</el-button>
                        </span>
                    </span>
                </el-tree>
            </el-card>
            <el-card shadow="never" class="user-card">
                <div slot="header" class="card-header">
                    <div>
                        <span>组织成员</span>
                        <span v-if="currentOrg" class="current-org">当前：{{ currentOrg.orgName }}</span>
                    </div>
                    <div>
                        <el-checkbox v-model="includeChildren" :true-label="1" :false-label="0" @change="loadUsers"
                            style="margin-right:15px;">包含下级组织</el-checkbox>
                        <el-button type="primary" size="mini" icon="el-icon-plus" :disabled="!currentOrg"
                            @click="openUserDialog">添加用户</el-button>
                    </div>
                </div>

                <el-empty v-if="!currentOrg" description="请先选择左侧组织"></el-empty>

                <el-table v-else v-loading="userLoading" :data="userList" border stripe style="width:100%;">
                    <el-table-column prop="userName" label="用户名" min-width="140" align="center"></el-table-column>
                    <el-table-column prop="telephone" label="手机号" min-width="120" align="center"></el-table-column>
                    <el-table-column prop="org_name" label="组织架构名称" min-width="120" align="center"></el-table-column>
                    <el-table-column label="操作" width="100" fixed="right" align="center">
                        <template slot-scope="{row}">
                            <el-button type="text" class="danger-btn" @click="handleRemoveUser(row)">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </div>

        <el-dialog :title="orgDialogTitle" :visible.sync="orgDialogVisible" width="520px" :close-on-click-modal="false">
            <el-form ref="orgForm" :model="orgForm" :rules="orgRules" label-width="100px">
                <el-form-item label="上级组织">
                    <el-input :value="parentOrgName" disabled></el-input>
                </el-form-item>
                <el-form-item label="组织名称" prop="orgName">
                    <el-input v-model="orgForm.orgName" placeholder="请输入组织名称"></el-input>
                </el-form-item>
                <el-form-item label="成员节点">
                    <el-radio-group v-model="orgForm.isMemberNode">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                    <div style="color:#909399;font-size:12px;margin-top:5px;">成员节点用于绑定普通员工，创建后不能再新增下级组织</div>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="orgForm.sortNo" :min="0" :max="9999"
                        style="width:100%;"></el-input-number>
                </el-form-item>
                <el-form-item label="状态">
                    <el-radio-group v-model="orgForm.status">
                        <el-radio :label="1">正常</el-radio>
                        <el-radio :label="0">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="orgForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="orgDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="orgSubmitLoading" @click="submitOrg">确定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="添加用户" :visible.sync="userDialogVisible" width="700px" :close-on-click-modal="false">
            <div style="display:flex;margin-bottom:12px;">
                <el-input v-model="userKeyword" placeholder="输入用户名或姓名搜索" clearable
                    @keyup.enter.native="searchUsers"></el-input>
                <el-button type="primary" style="margin-left:10px;" @click="searchUsers">查询</el-button>
            </div>
            <el-table v-loading="selectUserLoading" :data="selectUserList" border stripe max-height="450">
                <el-table-column prop="userName" label="用户名" align="center"></el-table-column>
                <el-table-column prop="telephone" label="手机号" align="center"></el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="{row}">
                        <el-button type="text" @click="addUser(row)">添加</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import { Baseurl, ajaxPost } from "@/api/api/api.js";

export default {
    name: "OrgManage",
    data() {
        return {
            treeData: [],
            filterText: "",
            currentOrg: null,
            includeChildren: 0,
            userList: [],
            userLoading: false,
            orgDialogVisible: false,
            orgDialogTitle: "",
            orgDialogType: "add",
            parentOrg: null,
            orgSubmitLoading: false,
            orgForm: { id: null, orgName: "", parentId: 0, isMemberNode: 0, sortNo: 0, status: 1, remark: "" },
            orgRules: { orgName: [{ required: true, message: "请输入组织名称", trigger: "blur" }], },
            userDialogVisible: false,
            userKeyword: "",
            selectUserList: [],
            selectUserLoading: false
        };
    },
    computed: {
        parentOrgName() {
            if (this.orgDialogType === "edit") {
                if (!this.orgForm.parentId) return "无";
                return this.findOrgName(this.orgForm.parentId);
            }
            return this.parentOrg ? this.parentOrg.orgName : "无";
        }
    },
    watch: {
        filterText(val) {
            this.$refs.orgTree && this.$refs.orgTree.filter(val);
        }
    },
    created() {
        this.loadTree();
    },
    methods: {
        loadTree() {
            ajaxPost(Baseurl + "org/tree", {}).then(res => {
                if (res.data.code === 200) {
                    this.treeData = this.formatTree(res.data.data || []);
                } else {
                    this.$message.error(res.data.msg || "组织架构加载失败");
                }
            });
        },
        formatTree(list) {
            return (list || []).map(item => {
                item.label = item.orgName;
                if (item.children && item.children.length) item.children = this.formatTree(item.children);
                return item;
            });
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.orgName && data.orgName.indexOf(value) !== -1;
        },
        handleNodeClick(data) {
            this.currentOrg = data;
            this.loadUsers();
        },
        handleAddRoot() {
            this.orgDialogType = "add";
            this.orgDialogTitle = "新增一级组织";
            this.parentOrg = null;
            this.resetOrgForm();
            this.orgForm.parentId = 0;
            this.orgDialogVisible = true;
        },
        handleAddChild(data) {
            if (data.isMemberNode === 1) {
                this.$message.warning("成员节点不能新增子级");
                return;
            }
            this.orgDialogType = "add";
            this.orgDialogTitle = "新增子组织";
            this.parentOrg = data;
            this.resetOrgForm();
            this.orgForm.parentId = data.id;
            this.orgDialogVisible = true;
        },
        handleEdit(data) {
            this.orgDialogType = "edit";
            this.orgDialogTitle = "编辑组织";
            this.parentOrg = null;
            this.orgForm = { id: data.id, orgName: data.orgName, parentId: data.parentId, isMemberNode: data.isMemberNode || 0, sortNo: data.sortNo || 0, status: data.status, remark: data.remark || "" };
            this.orgDialogVisible = true;
        },
        resetOrgForm() {
            this.orgForm = { id: null, orgName: "", parentId: 0, isMemberNode: 0, sortNo: 0, status: 1, remark: "" };
            this.$nextTick(() => {
                if (this.$refs.orgForm) {
                    this.$refs.orgForm.clearValidate();
                }
            });
        },
        submitOrg() {
            this.$refs.orgForm.validate(valid => {
                if (!valid) return;
                this.orgSubmitLoading = true;
                let url = this.orgDialogType === "add" ? "org/add" : "org/update";
                ajaxPost(Baseurl + url, this.orgForm).then(res => {
                    this.orgSubmitLoading = false;
                    if (res.data.code === 200) {
                        this.$message.success(this.orgDialogType === "add" ? "新增成功" : "修改成功");
                        this.orgDialogVisible = false;
                        this.loadTree();
                    } else {
                        this.$message.error(res.data.msg || "操作失败");
                    }
                }).catch(() => {
                    this.orgSubmitLoading = false;
                });
            });
        },
        handleDelete(data) {
            this.$confirm("确定删除组织【" + data.orgName + "】吗？有子组织或用户时不能删除。", "提示", { type: "warning" }).then(() => {
                ajaxPost(Baseurl + "org/delete", { id: data.id }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success("删除成功");
                        if (this.currentOrg && this.currentOrg.id === data.id) {
                            this.currentOrg = null;
                            this.userList = [];
                        }
                        this.loadTree();
                    } else {
                        this.$message.error(res.data.msg || "删除失败");
                    }
                });
            }).catch(() => { });
        },
        loadUsers() {
            if (!this.currentOrg) return;
            this.userLoading = true;
            ajaxPost(Baseurl + "org/users", { orgId: this.currentOrg.id, includeChildren: this.includeChildren }).then(res => {
                this.userLoading = false;
                if (res.data.code === 200) {
                    this.userList = res.data.data || [];
                } else {
                    this.$message.error(res.data.msg || "用户查询失败");
                }
            }).catch(() => {
                this.userLoading = false;
            });
        },
        openUserDialog() {
            if (!this.currentOrg) {
                this.$message.warning("请先选择组织");
                return;
            }
            this.userKeyword = "";
            this.selectUserList = [];
            this.userDialogVisible = true;
            this.searchUsers();
        },
        searchUsers() {
            this.selectUserLoading = true;
            ajaxPost(Baseurl + "org/searchUser", { keyword: this.userKeyword, pageNum: 1, pageSize: 100 }).then(res => {
                this.selectUserLoading = false;
                if (res.data.code === 200) {
                    let data = res.data.data;
                    this.selectUserList = data && data.list ? data.list : (data && data.records ? data.records : (data || []));
                } else {
                    this.$message.error(res.data.msg || "用户查询失败");
                }
            }).catch(() => {
                this.selectUserLoading = false;
            });
        },
        addUser(row) {
            ajaxPost(Baseurl + "org/addUser", { orgId: this.currentOrg.id, userId: row.uid }).then(res => {
                if (res.data.code === 200) {
                    this.$message.success("添加成功");
                    this.loadUsers();
                } else {
                    this.$message.error(res.data.msg || "添加失败");
                }
            });
        },
        handleRemoveUser(row) {
            this.$confirm("确定将该用户从当前组织移除吗？", "提示", { type: "warning" }).then(() => {
                ajaxPost(Baseurl + "org/removeUser", { orgId: row.org_id, userId: row.uid }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success("移除成功");
                        this.loadUsers();
                    } else {
                        this.$message.error(res.data.msg || "移除失败");
                    }
                });
            }).catch(() => { });
        },
        getDefaultChildType(type) {
            if (type === "COMPANY") return "DEPARTMENT";
            if (type === "DEPARTMENT") return "GROUP";
            return "TEAM";
        },
      
        findOrgName(id) {
            let result = "";
            const find = list => {
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === id) {
                        result = list[i].orgName;
                        return true;
                    }
                    if (list[i].children && find(list[i].children)) return true;
                }
                return false;
            };
            find(this.treeData);
            return result || "无";
        }
    }
};
</script>

<style scoped lang="scss">
.org-page {
    background: #f5f7fa;
    /* min-height: 750px; */
    width: 100%;
    height: 100%;
    .org-box{
        display: flex;
        height: calc(100% - 30px);
        .org-card{
            width: 300px;
            margin-right: 20px;
        }
        .user-card{
            flex: 1;
        }
    }
}

.org-card,
.user-card {
    // min-height: 720px;
    height: 100%;
}

.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
}

.current-org {
    margin-left: 15px;
    color: #909399;
    font-size: 13px;
    font-weight: normal;
}

.custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 8px;
}

.tree-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tree-name i {
    margin-right: 5px;
}

.tree-actions {
    display: none;
    white-space: nowrap;
    .el-button{
        margin: 0;
        padding: 0 5px;
    }
}

.custom-tree-node:hover .tree-actions {
    display: inline-block;
}

.danger-btn {
    color: #f56c6c;
}
</style>